import React from 'react'
import Button from './button'
import { Icons } from '../../lib/Icons'

export default function EmptyState({
  title = 'Nothing here yet',
  description = 'Get started by creating your first item.',
  actionLabel,
  onAction,
  className = '',
  children,
}) {
  return (
    <div className={[
      'flex flex-col items-center justify-center text-center bg-white rounded-2xl border border-gray-200 p-8',
      className,
    ].join(' ')}>
      <div className="flex justify-center mb-4"><Icons.Sparkles className="w-16 h-16 text-gray-400" /></div>
      <h3 className="text-lg font-semibold text-gray-900 mb-1">{title}</h3>
      <p className="text-sm text-gray-600 mb-4">{description}</p>
      {children}
      {actionLabel && (
        <Button onClick={onAction} className="mt-2">{actionLabel}</Button>
      )}
    </div>
  )
}

